import r, { useReducer as w, useMemo as x, useContext as G, useEffect as k, createContext as P } from "react";
function c() {
  return c = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var E = arguments[n];
      for (var i in E)
        ({}).hasOwnProperty.call(E, i) && (e[i] = E[i]);
    }
    return e;
  }, c.apply(null, arguments);
}
function $(e, n) {
  if (e == null)
    return {};
  var E = {};
  for (var i in e)
    if ({}.hasOwnProperty.call(e, i)) {
      if (n.includes(i))
        continue;
      E[i] = e[i];
    }
  return E;
}
function J() {
  function e(n) {
    for (var E = "", i = 0; i < n; i++)
      E += Math.floor(Math.random() * 16).toString(16);
    return E;
  }
  return e(8) + "-" + e(4) + "-4" + e(3) + "-" + (Math.floor(Math.random() * 4) + 8).toString(16) + e(3) + "-" + e(12);
}
var W = {}, B = function(n) {
  W = n;
}, j = function() {
  return W;
}, K = {
  onFocus: "focus",
  onBlur: "blur",
  onUpdate: "update",
  onDelete: "delete",
  onKeyUp: "keyup",
  onKeyDown: "keydown",
  onKeyPress: "keypress"
}, O = {
  TEXT: {
    type: "text",
    placeholder: "Cardholder Name"
  },
  CARD_NUMBER: {
    type: "card-number",
    placeholder: "Credit Card Number"
  },
  CARD_EXPIRATION_DATE: {
    type: "card-expiration-date",
    placeholder: "Card Expiration Date"
  },
  CARD_SECURITY_CODE: {
    type: "card-security-code",
    placeholder: "CVC/CVV"
  },
  PASSWORD: {
    type: "password",
    placeholder: "Enter password"
  },
  SSN: {
    type: "ssn",
    placeholder: "SSN"
  },
  ZIP_CODE: {
    type: "zip-code",
    placeholder: "Zip Code"
  },
  TEXTAREA: {
    type: "textarea",
    placeholder: "Comment"
  },
  NUMBER: {
    type: "number",
    placeholder: "Number"
  },
  FILE: {
    type: "file",
    placeholder: ""
  },
  DATE: {
    type: "date",
    placeholder: ""
  }
}, X = {
  formCreated: !1
}, C = /* @__PURE__ */ P(X), S = /* @__PURE__ */ P({}), t = function(n, E) {
  switch (E.type) {
    case "FORM_MOUNTED":
      return c({}, n, {
        formCreated: !0
      });
    case "FORM_UNMOUNTED":
      return c({}, n, {
        formCreated: !1
      });
    default:
      return n;
  }
}, p = function(n) {
  var E = n.children, i = w(t, X), R = i[0], F = i[1], N = x(function() {
    return R;
  }, [R]);
  return /* @__PURE__ */ r.createElement("div", null, /* @__PURE__ */ r.createElement(C.Provider, {
    value: N
  }, /* @__PURE__ */ r.createElement(S.Provider, {
    value: F
  }, E)));
}, H = function() {
  return [G(C)];
}, ee = ["className", "onFocus", "onBlur", "onUpdate", "onDelete", "onKeyPress", "onKeyUp", "onKeyDown", "style"];
function o(e) {
  var n = e.className, E = e.onFocus, i = e.onBlur, R = e.onUpdate, F = e.onDelete, N = e.onKeyPress, u = e.onKeyUp, g = e.onKeyDown, D = e.style, M = $(e, ee), f = c({}, M, D && {
    css: D
  });
  if (!e.name)
    throw new Error("@vgs/collect-js-react: name attribute for " + e.type + " is required.");
  var h = r.useState(function() {
    return "vgs-" + J();
  }), I = h[0], T = {
    onFocus: E,
    onBlur: i,
    onUpdate: R,
    onKeyUp: u,
    onKeyDown: g,
    onKeyPress: N,
    onDelete: F
  }, y = H(), l = y[0], d = Object.keys(T).filter(function(L) {
    return T[L] !== void 0;
  });
  return k(function() {
    var L = j();
    if (Object.keys(L).length !== 0 && (l == null ? void 0 : l.formCreated) === !0) {
      var v = L.field("#" + I, f);
      return d.forEach(function(m) {
        v.on(K[m], function(a) {
          T[m](a);
        });
      }), function() {
        try {
          var m;
          v == null || (m = v.delete) === null || m === void 0 || m.call(v);
        } catch (a) {
          if (!(a instanceof Error) || a instanceof Error && a.message !== "The field '" + (f == null ? void 0 : f.name) + "' is already deleted")
            throw a;
        }
        d.forEach(function(a) {
          v.off(K[a], function(b) {
            T[a](b);
          });
        });
      };
    }
  }, [l == null ? void 0 : l.formCreated]), /* @__PURE__ */ r.createElement("div", {
    className: "vgs-collect-iframe-wr " + (n || ""),
    id: I,
    "data-testid": "vgs-collect-field-wrapper"
  });
}
var re = /* @__PURE__ */ r.memo(function(e) {
  return /* @__PURE__ */ r.createElement(o, Object.assign({}, Object.assign(c({}, O.TEXT), e)));
}), ne = /* @__PURE__ */ r.memo(function(e) {
  return /* @__PURE__ */ r.createElement(o, Object.assign({}, Object.assign(c({}, O.CARD_NUMBER), e)));
}), Ee = /* @__PURE__ */ r.memo(function(e) {
  return /* @__PURE__ */ r.createElement(o, Object.assign({}, Object.assign(c({}, O.CARD_EXPIRATION_DATE), e)));
}), ie = /* @__PURE__ */ r.memo(function(e) {
  return /* @__PURE__ */ r.createElement(o, Object.assign({}, Object.assign(c({}, O.CARD_SECURITY_CODE), e)));
}), le = /* @__PURE__ */ r.memo(function(e) {
  return /* @__PURE__ */ r.createElement(o, Object.assign({}, Object.assign(c({}, O.PASSWORD), e)));
}), ce = /* @__PURE__ */ r.memo(function(e) {
  return /* @__PURE__ */ r.createElement(o, Object.assign({}, Object.assign(c({}, O.SSN), e)));
}), Te = /* @__PURE__ */ r.memo(function(e) {
  return /* @__PURE__ */ r.createElement(o, Object.assign({}, Object.assign(c({}, O.ZIP_CODE), e)));
}), ae = /* @__PURE__ */ r.memo(function(e) {
  return /* @__PURE__ */ r.createElement(o, Object.assign({}, Object.assign(c({}, O.TEXTAREA), e)));
}), Oe = /* @__PURE__ */ r.memo(function(e) {
  return /* @__PURE__ */ r.createElement(o, Object.assign({}, Object.assign(c({}, O.NUMBER), e)));
}), oe = /* @__PURE__ */ r.memo(function(e) {
  return /* @__PURE__ */ r.createElement(o, Object.assign({}, Object.assign(c({}, O.DATE), e)));
}), _e = /* @__PURE__ */ r.memo(function(e) {
  return /* @__PURE__ */ r.createElement(o, Object.assign({}, Object.assign(c({}, O.FILE), e)));
}), s = void 0, Re = /* @__PURE__ */ P(s), Z = /* @__PURE__ */ P({}), Ne = /* @__PURE__ */ P(s), z = /* @__PURE__ */ P({}), Ie = /* @__PURE__ */ P(!1), q = /* @__PURE__ */ P({}), me = function(n) {
  var E = n.children, i = w(function(y, l) {
    return l ? c({}, l) : s;
  }, s), R = i[0], F = i[1], N = w(function(y, l) {
    return l ? c({}, l) : s;
  }, s), u = N[0], g = N[1], D = w(function(y, l) {
    return l || null;
  }, null), M = D[0], f = D[1], h = x(function() {
    return R;
  }, [R]), I = x(function() {
    return u;
  }, [u]), T = x(function() {
    return M;
  }, [M]);
  return /* @__PURE__ */ r.createElement("div", null, /* @__PURE__ */ r.createElement(Ne.Provider, {
    value: h
  }, /* @__PURE__ */ r.createElement(z.Provider, {
    value: F
  }, /* @__PURE__ */ r.createElement(Re.Provider, {
    value: I
  }, /* @__PURE__ */ r.createElement(Z.Provider, {
    value: g
  }, /* @__PURE__ */ r.createElement(Ie.Provider, {
    value: T
  }, /* @__PURE__ */ r.createElement(q.Provider, {
    value: f
  }, E)))))));
}, ve = function(n) {
  var E = n.children;
  return /* @__PURE__ */ r.createElement(me, null, E);
}, Ae = typeof window < "u";
function De(e) {
  var n = e.vaultId, E = e.environment, i = E === void 0 ? "sandbox" : E, R = e.action, F = R === void 0 ? "/" : R, N = e.cname, u = e.routeId, g = e.submitParameters, D = e.tokenizationAPI, M = D === void 0 ? !1 : D, f = e.onCustomSubmit, h = e.onUpdateCallback, I = e.onSubmitCallback, T = e.onErrorCallback, y = e.children;
  if (!n)
    throw new Error("@vgs/collect-js-react: vaultId is required.");
  var l = G(z), d = G(Z), L = G(S), v = G(q), m = typeof l == "function" && typeof d == "function";
  k(function() {
    if (Ae && window.VGSCollect && Object.keys(j()).length === 0) {
      var b = window.VGSCollect.create(n, i, function(A) {
        h && h(A), m && l(A);
      });
      L({
        type: "FORM_MOUNTED"
      }), N && b.useCname(N), u && b.setRouteId(u), B(b), v(j());
    }
    return function() {
      var A = j();
      Object.keys(A).length !== 0 && (A.unmount(), B({})), m && (l(null), d(null)), L({
        type: "FORM_UNMOUNTED"
      });
    };
  }, []);
  var a = function(A) {
    A.preventDefault();
    var V = j();
    if (!V)
      throw new Error("@vgs/collect-js-react: VGS Collect form not found.");
    M ? V.tokenize(function(U, Y) {
      I && I(U, Y);
    }, function(U) {
      T && T(U);
    }) : V.submit(F, g, function(U, Y) {
      I && I(U, Y), d({
        status: U,
        data: Y
      });
    }, function(U) {
      T && T(U);
    });
  };
  return /* @__PURE__ */ r.createElement("form", {
    onSubmit: function(A) {
      return (f || a)(A);
    }
  }, y);
}
function _(e) {
  return /* @__PURE__ */ r.createElement(p, null, /* @__PURE__ */ r.createElement(De, Object.assign({}, e)));
}
_.TextField = re;
_.CardNumberField = ne;
_.CardExpirationDateField = Ee;
_.CardSecurityCodeField = ie;
_.PasswordField = le;
_.SSNField = ce;
_.ZipCodeField = Te;
_.TextareaField = ae;
_.NumberField = Oe;
_.FileField = _e;
_.DateField = oe;
var Q;
(function(e) {
  e[e.CONTINUE = 100] = "CONTINUE", e[e.SWITCHING_PROTOCOLS = 101] = "SWITCHING_PROTOCOLS", e[e.PROCESSING = 102] = "PROCESSING", e[e.OK = 200] = "OK", e[e.CREATED = 201] = "CREATED", e[e.ACCEPTED = 202] = "ACCEPTED", e[e.NON_AUTHORITATIVE_INFORMATION = 203] = "NON_AUTHORITATIVE_INFORMATION", e[e.NO_CONTENT = 204] = "NO_CONTENT", e[e.RESET_CONTENT = 205] = "RESET_CONTENT", e[e.PARTIAL_CONTENT = 206] = "PARTIAL_CONTENT", e[e.MULTI_STATUS = 207] = "MULTI_STATUS", e[e.ALREADY_REPORTED = 208] = "ALREADY_REPORTED", e[e.IM_USED = 226] = "IM_USED", e[e.MULTIPLE_CHOICES = 300] = "MULTIPLE_CHOICES", e[e.MOVED_PERMANENTLY = 301] = "MOVED_PERMANENTLY", e[e.FOUND = 302] = "FOUND", e[e.SEE_OTHER = 303] = "SEE_OTHER", e[e.NOT_MODIFIED = 304] = "NOT_MODIFIED", e[e.USE_PROXY = 305] = "USE_PROXY", e[e.SWITCH_PROXY = 306] = "SWITCH_PROXY", e[e.TEMPORARY_REDIRECT = 307] = "TEMPORARY_REDIRECT", e[e.PERMANENT_REDIRECT = 308] = "PERMANENT_REDIRECT", e[e.BAD_REQUEST = 400] = "BAD_REQUEST", e[e.UNAUTHORIZED = 401] = "UNAUTHORIZED", e[e.PAYMENT_REQUIRED = 402] = "PAYMENT_REQUIRED", e[e.FORBIDDEN = 403] = "FORBIDDEN", e[e.NOT_FOUND = 404] = "NOT_FOUND", e[e.METHOD_NOT_ALLOWED = 405] = "METHOD_NOT_ALLOWED", e[e.NOT_ACCEPTABLE = 406] = "NOT_ACCEPTABLE", e[e.PROXY_AUTHENTICATION_REQUIRED = 407] = "PROXY_AUTHENTICATION_REQUIRED", e[e.REQUEST_TIMEOUT = 408] = "REQUEST_TIMEOUT", e[e.CONFLICT = 409] = "CONFLICT", e[e.GONE = 410] = "GONE", e[e.LENGTH_REQUIRED = 411] = "LENGTH_REQUIRED", e[e.PRECONDITION_FAILED = 412] = "PRECONDITION_FAILED", e[e.PAYLOAD_TOO_LARGE = 413] = "PAYLOAD_TOO_LARGE", e[e.URI_TOO_LONG = 414] = "URI_TOO_LONG", e[e.UNSUPPORTED_MEDIA_TYPE = 415] = "UNSUPPORTED_MEDIA_TYPE", e[e.RANGE_NOT_SATISFIABLE = 416] = "RANGE_NOT_SATISFIABLE", e[e.EXPECTATION_FAILED = 417] = "EXPECTATION_FAILED", e[e.I_AM_A_TEAPOT = 418] = "I_AM_A_TEAPOT", e[e.MISDIRECTED_REQUEST = 421] = "MISDIRECTED_REQUEST", e[e.UNPROCESSABLE_ENTITY = 422] = "UNPROCESSABLE_ENTITY", e[e.LOCKED = 423] = "LOCKED", e[e.FAILED_DEPENDENCY = 424] = "FAILED_DEPENDENCY", e[e.UPGRADE_REQUIRED = 426] = "UPGRADE_REQUIRED", e[e.PRECONDITION_REQUIRED = 428] = "PRECONDITION_REQUIRED", e[e.TOO_MANY_REQUESTS = 429] = "TOO_MANY_REQUESTS", e[e.REQUEST_HEADER_FIELDS_TOO_LARGE = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE", e[e.UNAVAILABLE_FOR_LEGAL_REASONS = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS", e[e.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", e[e.NOT_IMPLEMENTED = 501] = "NOT_IMPLEMENTED", e[e.BAD_GATEWAY = 502] = "BAD_GATEWAY", e[e.SERVICE_UNAVAILABLE = 503] = "SERVICE_UNAVAILABLE", e[e.GATEWAY_TIMEOUT = 504] = "GATEWAY_TIMEOUT", e[e.HTTP_VERSION_NOT_SUPPORTED = 505] = "HTTP_VERSION_NOT_SUPPORTED", e[e.VARIANT_ALSO_NEGOTIATES = 506] = "VARIANT_ALSO_NEGOTIATES", e[e.INSUFFICIENT_STORAGE = 507] = "INSUFFICIENT_STORAGE", e[e.LOOP_DETECTED = 508] = "LOOP_DETECTED", e[e.NOT_EXTENDED = 510] = "NOT_EXTENDED", e[e.NETWORK_AUTHENTICATION_REQUIRED = 511] = "NETWORK_AUTHENTICATION_REQUIRED", e.NETWORK_ERROR = "Network Error";
})(Q || (Q = {}));
export {
  q as DispatchFormInstanceContext,
  z as DispatchStateContext,
  Z as DispatchSubmitContext,
  Ie as GlobalFormInstanceContext,
  Ne as GlobalStateContext,
  me as GlobalStateProvider,
  Re as GlobalSubmitContext,
  _ as VGSCollectForm,
  ve as VGSCollectProvider,
  s as initialState
};
